import { AutogenLayoutTablePropertyList } from "./autogen/AutogenLayoutTablePropertyList";

export class TablePropertyList extends AutogenLayoutTablePropertyList {

    override async onLoad() {
        this.switchHeaderIsAudited.allowIndeterminate = true;
        this.switchHeaderIsAudited.checked = undefined;
        this.switchHeaderIsAuditedDelete.allowIndeterminate = true;
        this.switchHeaderIsAuditedDelete.checked = undefined;
        this.switchHeaderIsAuditedInsert.allowIndeterminate = true;
        this.switchHeaderIsAuditedInsert.checked = undefined;
        this.switchHeaderIsAuditedUpdate.allowIndeterminate = true;
        this.switchHeaderIsAuditedUpdate.checked = undefined;
        this.switchHeaderIsBroadcasted.allowIndeterminate = true;
        this.switchHeaderIsBroadcasted.checked = undefined;
        this.switchHeaderIsQueryRestrict.allowIndeterminate = true;
        this.switchHeaderIsQueryRestrict.checked = undefined;
        this.switchHeaderIsShared.allowIndeterminate = true;
        this.switchHeaderIsShared.checked = undefined;
    }

    /** This is an event handler for the onClick event of buttonExpand. */
    buttonExpandOnClick() {

    }

    /** This is an event handler for the onClick event of buttonResetForm. */
    buttonResetFormOnClick() {
        this.textboxTableName.clear();
        this.switchHeaderIsShared.checked = undefined;
        this.switchHeaderIsBroadcasted.checked = undefined;
        this.switchHeaderIsQueryRestrict.checked = undefined;
        this.switchHeaderIsAudited.checked = undefined;
        this.textboxDaysToKeep.clear();
        this.switchHeaderIsAuditedInsert.checked = undefined;
        this.switchHeaderIsAuditedUpdate.checked = undefined;
        this.switchHeaderIsAuditedDelete.checked = undefined;
    }
}
